<div class="approval-feedback-section box_default box_white" >
  <header>
    <h3>FEEDBACK</h3>
  </header>
  
  <div class="loader">
    <div class="dimmed" [hidden]="messagesList != null">
      <div class="dimmed_avatar"></div>
      <div class="dimmed_info">
        <div class="dimmed_title"></div>
        <div class="dimmed_subtitle"></div>
      </div>
    </div>
  </div>

  
  <article *ngIf="messagesList != null" class="messages-section-main">
    <!-- add form -->
    <div class="version-messages-form" *ngIf="msgActionAccess">
      <core-message-add
            [action]="messageAddUrl"
            [context]="context"
            [user]="user"
            [hash]="hash"
            (onSaved)="onUpdateMessages($event)">
        </core-message-add>
    </div>
    <!-- list -->
    <div class="version-details-comments-list">
      <article *ngIf="messagesList!=null && messagesList.length==0" class="message-not-content">
        <core-helpers-box-alert-message-icon
          [text]="'There are currently no messages.'"
          [icon]="'no_messages'"
        ></core-helpers-box-alert-message-icon>
      </article>
      <ul class="comments-list" *ngIf="messagesList.length > 0">
        <li class="comments-timeline-item" *ngFor="let vmessage of messagesList | sortBy: 'date' : 'desc'; let i = index; trackBy: trackByMessageId ">
          <!-- jan-2023 new 3 types messages for feedback -->
            <ng-container [ngSwitch]="vmessage.type">
              <ng-template [ngSwitchCase]="VERSION_SHARE_MESSAGE_TYPE.TEXT_MESSAGE_TYPE">
                  <core-message
                    [message]="vmessage.message"
                    [versionShares]="vmessage.user_version_shares ? vmessage.user_version_shares : null"
                    [notesActionText]="msgActionAccess ? 'Add Notes' : 'See Notes'"
                    [notesActionStyle]="msgActionAccess ? 'add-notes' : 'see-notes'"
                    [canCreateNotes]="msgActionAccess"
                    [delete]="msgActionAccess && vmessage.message.user.id == user.id"
                    (onDelete)="onDeleteMessage($event)"
                    [prefixUrl]="prefixUrl"
                    [prefixDeleteUrl]="prefixDeleteUrl"
                    [context]="context"
                  ></core-message>
                  
                  <!-- Display file attachments directly with core-signed-files-list -->
                  <div class="message-attachments" *ngIf="vmessage.message?.attachments?.length > 0">
                    <header>
                      <h4 *ngIf="isAttachmentsOpen(vmessage.message)" (click)="toggleAttachments(vmessage.message)"><em>{{vmessage.message?.attachments?.length}}</em> <span
                          class="arrow-up">Attachment{{vmessage.message?.attachments?.length > 1 ? 's':''}}</span></h4>
                      <h4 *ngIf="!isAttachmentsOpen(vmessage.message)" (click)="toggleAttachments(vmessage.message)"><em>{{vmessage.message?.attachments?.length}}</em> <span
                          class="arrow-down">Attachment{{vmessage.message?.attachments?.length > 1 ? 's':''}}</span></h4>
                    </header>
                  <div [hidden]="!isAttachmentsOpen(vmessage.message)" class="message-attachments-content feedbacks">
                    <core-signed-files-list 
                        *ngIf="vmessage.message?.attachments?.length > 0"
                        [files]="vmessage.message.attachments"
                        [notes]="getNotesForMessage(vmessage.message)"
                        [annotationsUrl]="'/messages/'+vmessage.message.id"
                        [canCreateNotes]="msgActionAccess"
                        [annotationsUser]="user"
                        [menu]="fileMenu"
                        [scope]="scope"
                        (refreshSignaturesNeeded)="onRefreshSignaturesNeeded()"
                        (menuClick)="onFileMenuClick($event)"
                        (iconDownloadClick)="onFileIconDownloadClick($event)"
                        (annotationsSaved)="onNotesSaved(vmessage.message, $event)"
                    ></core-signed-files-list>
                    </div>
                  </div>
              </ng-template>
              <!-- Message of uploaded version actions -->
              <ng-template [ngSwitchCase]="VERSION_SHARE_MESSAGE_TYPE.UPLOADED_MESSAGE_TYPE">
                  <core-message-version-share-feedback
                      [message]="vmessage"
                  ></core-message-version-share-feedback>
                  <div class="approval-box-uploaded-version" *ngIf="getVersionUpload(vmessage) as upVersion">
                    <core-versions-summary-box 
                        [version]="upVersion"
                        [versionShares]="[]" 
                        [menu]="menuVersion"
                        (menuClick)="onVersionMenuClick($event)"
                        (actionFileClick)="onClickVersionPreview($event,upVersion)"
                    ></core-versions-summary-box>
                  </div>
              </ng-template>
              <!-- Message of approved/rejected actions -->
              <ng-template [ngSwitchCase]="VERSION_SHARE_MESSAGE_TYPE.APPROVAL_MESSAGE_TYPE">
                  <core-message-version-share-feedback
                      [message]="vmessage"
                  ></core-message-version-share-feedback>
              </ng-template>
              <!-- TO REVIEW ng17 when no ngSwitchDefault due to strict comparison -->
          </ng-container>
        </li>
      </ul>
    </div>
  </article>
</div>
